import { FHWA_Aussere } from "./FHWA_Aussere";
import { FHWA_Innere } from "./FHWA_Innere";
//import { FHWA_Innere } from "./FHWA_Innere";

export function FHWA({ data, settings }) {
  let showInnere = settings.find((item) => {
    return item.name === "aashtoInnere";
  });

  let showAussere = settings.find((item) => {
    return item.name === "aashtoAussere";
  });
  return (
    <>
      {showInnere && showInnere.value && <FHWA_Innere data={data} />}
      {showAussere && showAussere.value && <FHWA_Aussere data={data} />}
    </>
  );
}
